import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../Main.module.scss';
import { clickHereToResetItText, somethingWentWrongText } from '../textConsts';

export const LoginErrorMessage = ({ error, resetPasswordUrl, onResetPasswordClick }) => {
    if (!error) return null;

    const renderErrorContent = () => {
        const errorText = typeof error === 'string' ? error : somethingWentWrongText;
        if (resetPasswordUrl) {
            return (
                <>
                    {errorText}{' '}
                    <button className={styles.resetPasswordLink} onClick={onResetPasswordClick} type="button">
                        {clickHereToResetItText}
                    </button>
                </>
            );
        }
        return errorText;
    };

    return <div className={styles.errorMessage}>{renderErrorContent()}</div>;
};

LoginErrorMessage.propTypes = {
    error: PropTypes.string,
    resetPasswordUrl: PropTypes.string,
    onResetPasswordClick: PropTypes.func
};
